import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import ActionTypes from "../../../constants/ActionTypes";
import ApiUrls from "../../../constants/ApiUrls";
import MiddlewareEntities from "../../../constants/MiddlewareEntities";
import ErrorCodes from "../../../constants/ErrorCodes";
import ProductFactory from "../../../factories/product/ProductFactory";
import { apiRequest } from "../api/actions";
import { createErrorNotification } from "../notification/actions";
import { getSessionData } from "../sessionData/actions";
import { setLoader } from "../ui/actions";
import { addProductOnWishListAction, removeProductFromWishListAction, setProductsForWishListAction } from "./actions";
import AnalyticsMiddlewareGA4Proxy from "../analytics/ga4/AnalyticsMiddlewareGA4Proxy";
import { normalizeProductTypeForWishlistRemoval } from "../../../utilites/wishlist";

export const wishListMiddlewareMain: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.WISH_LIST.CHANGE_PRODUCT:
    // This if is neccessary to be here because setLoader changes the ui entity
    // and analytics middleware uses the ui entity to determine whether the wishlist change
    // comes from the product list or the product overview.
    if (action.payload.status) {
      AnalyticsMiddlewareGA4Proxy.addToWishlist(store.getState(), action.payload.productId);
    }

    next(setLoader(true, MiddlewareEntities.WISH_LIST.CHANGE));

    if (action.payload.status) {
      next(apiRequest(
        null,
        'POST',
        ApiUrls.WISH_LIST,
        null,
        {
          lang: action.payload.lang,
          section: action.payload.section,
          productId: action.payload.productId,
          type: action.payload.type
        },
        MiddlewareEntities.WISH_LIST.CHANGE,
        {}),
      );

      localStorage.removeItem("savedWishListProduct");

      return next(addProductOnWishListAction(action.payload.productId));
    }

    next(apiRequest(
      null,
      'PATCH',
      ApiUrls.WISH_LIST,
      null,
      {
        lang: action.payload.lang,
        section: action.payload.section,
        productId: action.payload.productId,
        type: normalizeProductTypeForWishlistRemoval(action.payload.type)
      },
      MiddlewareEntities.WISH_LIST.CHANGE,
      {}),
    );

    return next(removeProductFromWishListAction(action.payload.productId));
  case ActionTypes.WISH_LIST.SAVE_PRODUCT_AFTER_LOGIN:
    localStorage.setItem("savedWishListProduct", JSON.stringify(action.payload));
    // set entity to know when to show wishlist popup as component
    next(setLoader(false, MiddlewareEntities.WISH_LIST.SAVE_PRODUCT));
    break;
  case ActionTypes.WISH_LIST.GET_PRODUCTS:
    next(apiRequest(
      null,
      'GET',
      ApiUrls.WISH_LIST,
      null,
      null,
      MiddlewareEntities.WISH_LIST.PRODUCTS,
      {}),
    );
    next(setLoader(true, MiddlewareEntities.WISH_LIST.PRODUCTS));
    break;
  case `${MiddlewareEntities.WISH_LIST.CHANGE} ${ActionTypes.API_SUCCESS}`:
    next(getSessionData(action.payload.data.session));
    next(setLoader(false, MiddlewareEntities.WISH_LIST.CHANGE_SUCCESS));
    break;
  case `${MiddlewareEntities.WISH_LIST.PRODUCTS} ${ActionTypes.API_SUCCESS}`:
    const productsEntities: any[] = [];
    action.payload.data.products.map((product: any) => {
      productsEntities.push(ProductFactory.createFromResponse(product));
    });
    next(setProductsForWishListAction(productsEntities));
    next(getSessionData(action.payload.data.session));
    next(setLoader(false, MiddlewareEntities.WISH_LIST.PRODUCTS));
    break;
  case `${MiddlewareEntities.WISH_LIST.PRODUCTS} ${ActionTypes.API_ERROR}`:
    next(setLoader(false, MiddlewareEntities.WISH_LIST.PRODUCTS));
    next(createErrorNotification(action.payload.data,  MiddlewareEntities.WISH_LIST.PRODUCTS));
    break;
  case `${MiddlewareEntities.WISH_LIST.CHANGE} ${ActionTypes.API_ERROR}`:
    if (action.payload.data.code !== ErrorCodes.WISH_LIST_DEVICE_ALREADY_EXISTS) {
      next(setLoader(false, MiddlewareEntities.WISH_LIST.CHANGE_ERROR));
      next(createErrorNotification(action.payload.data,  MiddlewareEntities.WISH_LIST.CHANGE_ERROR));
    } else {
      next(setLoader(false, MiddlewareEntities.WISH_LIST.CHANGE));
    }
    break;
  }
};

export const wishListMiddleware = [
  wishListMiddlewareMain
];

